import { render } from "./DateRangePicker2.vue?vue&type=template&id=b9ba5cc2&scoped=true"
import script from "./DateRangePicker2.vue?vue&type=script&lang=js"
export * from "./DateRangePicker2.vue?vue&type=script&lang=js"

import "./DateRangePicker2.vue?vue&type=style&index=0&id=b9ba5cc2&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ba5cc2"]])

export default __exports__